import { isRecencyFilter, RECENCY_OPTIONS } from './helpers'
import type { RecencyFilter } from './types'

/**
 * "Which deal was just added or changed?" (R-12): keep the deals added, or last
 * modified, today or in the last 7 or 30 days. The same choice on the Pipeline's
 * filters and over the Command Center's deal table.
 */
export function RecencySelect({
  value,
  onChange,
  className,
}: {
  value: RecencyFilter | undefined
  onChange: (next: RecencyFilter | undefined) => void
  className?: string
}) {
  return (
    <select
      aria-label="Added or modified"
      value={value ?? ''}
      onChange={(event) => onChange(isRecencyFilter(event.target.value) ? event.target.value : undefined)}
      className={className}
    >
      <option value="" className="bg-black text-white">
        Any time
      </option>
      {RECENCY_OPTIONS.map((option) => (
        <option key={option.value} value={option.value} className="bg-black text-white">
          {option.label}
        </option>
      ))}
    </select>
  )
}
